ActivityMemberMenuView = require 'views/member-menu-profile/activity-member-menu-view'
Dates = require 'lib/dates'
Dialog = require 'views/lib/dialog'
Entity = require('views/templates/entity-react')
friendlyLinks = require 'views/internal/friendly-links'
log = require 'debug/log'
MemberAvatar = require 'views/member/member-avatar-react'
ModelCache = require 'db/model-cache'
{ PopulatingMinimalCanonicalCard } = require 'views/canonical-card/populating-canonical-card'
PopOver = require 'views/lib/pop-over'
React = require 'react'
SimpleTest = require 'lib/experiments/simple-test'
t = require('views/internal/recup-with-helpers')('notification')
Tooltip = require 'views/lib/tooltip'
l = require 'lib/localize'
track = require 'debug/track'
Util = require 'lib/util'
_ = require 'underscore'
$ = require 'jquery'

isDeletedMember = (notification) ->
  notification.entities?[0].idContext?.entities?.memberCreator?.translationKey == "notification_deleted_account"

module.exports = class NotificationView extends React.Component
  el: null
  displayName: 'Notification'

  getIcon: (iconKey) ->
    iconKey = iconKey.replace('notification_', '')
    switch iconKey
      when 'added_attachment_to_card' then 'attachment'
      when 'added_a_due_date', 'changed_due_date', 'is_due', 'card_due_soon', 'is_due', 'was_due' then 'clock'
      when 'added_to_card', 'added_to_organization', 'added_to_board' then 'add-member'
      when 'removed_from_board', 'removed_from_card', 'removed_from_organization' then 'remove-member.icon-custom'
      when 'archived_card', 'unarchived_card' then 'archive'
      when 'moved_card', 'created_card' then 'forward'
      when 'comment_card', 'mentioned_on_card' then 'comment'
      when 'made_admin_of_board', 'made_admin_of_organization' then 'member'
      when 'close_board' then 'close'
      when 'reopen_board' then 'refresh'
      else 'member'

  componentDidMount: ->
    @mounted = true

  componentWillUnmount: ->
    @mounted = false

  constructor: (props) ->
    super(props)

    @state = {
      isArchiveVisible: false
    }

  render: t.renderable ->
    { board
    , card
    , list
    , isCommentLike
    , isAddAttachment
    , unread
    , type
    , isDueDateNotification
    , isEnterpriseAdmin
    , date
    , isDeclinedInvitationNotification
    , entities
    , member
    , context
    , showArchiveButton
    , archive
    , active
    } = @props

    {
      archiveHeight
      isArchiveVisible
    } = @state

    isShowCards = SimpleTest('cardNotifications').get('showCards') && context == "header"

    t.div
      class: t.classify({
        'mod-comment-type': isCommentLike,
        'mod-attachment-type': isAddAttachment,
        'mod-unread': unread,
        'mod-due-soon': type == 'cardDueSoon'
        'mod-is-card': card? && isShowCards
        'mod-is-not-card': !card? && isShowCards
        'archive-visible': isArchiveVisible && isShowCards
        'phenom': true
        }),
      ref: (el) =>
        @el = el
        Dates.update(el)
        _.each el?.querySelectorAll('.js-friendly-links'), (el) ->
          friendlyLinks el
      onClick: if isShowCards then null else @clickedNotification.bind(@)
    , =>
      if isShowCards
        t.div
          onMouseEnter: @showTooltip
          onMouseLeave: @hideTooltip
          onClick: (e) =>
            @hideTooltip()
            if isShowCards
              @clickedNotification(e)
          class: t.classify({
            'js-toggle-read': true,
            'mark-read': unread,
            'mark-unread': !unread
          })
          'aria-label': l(['notification', if unread
            'mark read'
          else
            'mark unread'])
        t.div '.unread-cover'
        if card? && board?
          t.tag PopulatingMinimalCanonicalCard, {
            isPolling: true
            cardName: card.name
            cardUrl: if card.shortLink? then "/c/#{card.shortLink}"
            boardName: board.name
            boardUrl: if board.shortLink? then "/b/#{board.shortLink}"
            idBoard: board.id
            idCard: card.id
            listName: list?.name
            isWide: true
          }

      if isShowCards
        renderNotification = (notification, i) =>
          { type
          , isDueDateNotification
          , isEnterpriseAdmin
          , date
          , isDeclinedInvitationNotification
          , entities
          , member
          , iconKey
          , unread
          } = notification

          t.div
            class: t.classify({
              'mod-due-soon': type == 'cardDueSoon',
              'notification': true
              }),
            onClick: @clickedNotification.bind(props: notification), =>
              if member && isShowCards
                t.div '.phenom-member.js-show-mem-menu.show-mem-menu', { 'data-idmember': member.id, onClick: @viewMemberActionMenu.bind(@) }, =>
                  t.div '.phenom-creator', =>
                    t.div '.member', ->
                      t.createElement MemberAvatar, member
                  t.div '.member-name', =>
                    t.text member.fullName
                  return
              else if isShowCards && isDeletedMember(notification)
                t.div '.phenom-member', =>
                  t.div '.member-name', =>
                    t.format 'deleted-account'
              t.div '.content-wrapper', =>
                t.div '.phenom-icon ', =>
                    t.span ".icon-sm.icon-#{@getIcon(iconKey)}"
                t.div '.phenom-desc', =>
                  _.forEach(entities, (entity) -> t.createElement Entity, { entity, context: {}, options: { isEnterpriseAdmin } })

                  t.p '.phenom-meta.quiet.u-width-100', ->
                    if date
                      t.span '.date', { 'data-date': date }

        if showArchiveButton
          t.button '.archive-button.quiet.unstyled-button',
            onClick: @toggleArchive.bind(@, false), =>
              t.icon 'down'
              if isArchiveVisible
                t.format 'hide-previous-card-activity'
              else
                t.format 'show-previous-card-activity'

        t.div
          style: { height: if isArchiveVisible && archiveHeight != 0 then archiveHeight }
          class: t.classify({
            'measuring': !archiveHeight? && isShowCards
            'archive': true
          }), =>
            archive?.forEach(renderNotification)

            t.button '.archive-button.quiet.unstyled-button',
              onClick: @toggleArchive.bind(@, true), =>
                t.icon 'down'
                t.format 'hide'

        active?.forEach(renderNotification)

      else
        t.div '.content-wrapper', =>
          t.div '.phenom-creator', =>
            if member
              t.div '.member.js-show-mem-menu', { 'data-idmember': member.id, onClick: @viewMemberActionMenu.bind(@) }, ->
                t.createElement MemberAvatar, member

            else
              if isDueDateNotification
                t.span '.icon-lg.icon-clock'
              else if isDeclinedInvitationNotification
                t.span '.icon-lg.icon-close'
              else
                # The user is probably deleted, but a human still did the action, so use
                # the member icon.
                t.span '.icon-lg.icon-member'

            return

          t.div '.phenom-desc', =>
            _.forEach(entities, (entity) -> t.createElement Entity, { entity, context: {}, options: { isEnterpriseAdmin } })

        t.p '.phenom-meta.quiet', ->
          if date
            t.span '.date', { 'data-date': date }

    log('notifications', @props)

  showTooltip: (e) ->
    $btn = @$(e.target)
    Tooltip.show($btn.attr('aria-label'), $btn, false, Tooltip.STYLE.MENU)

  hideTooltip: ->
    Tooltip.hide()

  toggleArchive: (shouldMaintainScroll = false) =>
    { isArchiveVisible, archiveHeight } = @state

    if !archiveHeight?
      @setState
        archiveHeight: $(@el).find('.archive').outerHeight()

      # We have to wait for the render to update before we toggle the visibility
      # otherwise the height won't have time to reset for the animation
      setTimeout(
        => if @mounted
          @setState isArchiveVisible: !isArchiveVisible,
        100
      )
    else
      @setState isArchiveVisible: !isArchiveVisible

    if(isArchiveVisible && archiveHeight? && shouldMaintainScroll)
      # Maintain the position of scroll.
      # 500ms is the speed in the css animation too.
      # So change both if changing this one
      scrollList = $('.notification-list-holder')
      scrollList.animate({
        scrollTop: scrollList.scrollTop() - archiveHeight
      }, 500)

  clickedNotification: (e) ->
    isShowCards = SimpleTest('cardNotifications').get('showCards')

    if @props.context == 'header'
      track("Header", "Notifications Menu", "Clicked Notification")
    else if @props.context == 'notifications-page'
      track("Member View", "Notifications Page", "Clicked Notification")

    # If the user clicked somewhere on the notification that wasn't a link, make our best guess as to where
    # they'd like to be sent.  For example, if it's a notification for a card, send them to the card.
    if !isShowCards
      @props.markRead()
    if isShowCards && $(e.target).is('.js-toggle-read')
      @props.toggleRead()
    else if !$(e.target).is('a')
      if !isShowCards
        @props.navigateToView()
      Util.stop(e)
    else if !(e.metaKey || e.ctrlKey)
      Dialog.hide() # Will no-op in when we're not in a dialog.

  viewMemberActionMenu: (e) ->
    Util.stop(e)

    member = ModelCache.get('Member', $(e.target).closest('[data-idmember]').attr("data-idmember") ? @props.idMemberCreator)

    if $(e.target).closest('.pop-over').length > 0
      PopOver.pushView
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    else
      PopOver.toggle
        elem: $(e.target).closest('.js-show-mem-menu')
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    return



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-view.coffee